export default "__VITE_ASSET__CxvR1SYQ__"